"use client";

import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Link,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import MenuIcon from "@mui/icons-material/Menu";
import Image from "next/image";

const Header: React.FC = () => {
  const isMobile = useMediaQuery("(max-width:900px)");

  return (
    <AppBar
      position="fixed"
      sx={{
        background:
          "linear-gradient(90deg, rgba(19,49,84,1) 0%, rgba(44,80,121,1) 100%)",
        width: "100%",
        zIndex: 1201,
        boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
        py: 1,
        borderBottom: "1px solid rgba(255,255,255,0.1)",
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
          px: { xs: 2, sm: 4 },
          maxWidth: "xl",
          mx: "auto",
          width: "100%",
        }}
      >
        {/* Brand Section with Logo */}
        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
          <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
            {/* Logo GIF with fallback styling */}
            <Box
              sx={{
                width: 50,
                height: 50,
                position: "relative",
                mr: 1.5,
              }}
            >
              <Image
                src="/logo.gif" // Make sure this is in your public folder
                alt="TSC Logo"
                fill
                style={{
                  objectFit: "contain",
                }}
                unoptimized={true} // Required for GIFs in Next.js
              />
            </Box>
          </Box>
          <Typography
            variant="h6"
            noWrap
            sx={{
              fontWeight: 700,
              letterSpacing: 0.5,
              color: "#ffffff",
              fontSize: { xs: "1rem", sm: "1.25rem" },
            }}
          >
            TEACHERS SERVICE COMMISSION
            <Box
              component="span"
              sx={{
                fontWeight: 400,
                ml: 1,
                display: { xs: "none", sm: "inline" },
              }}
            >
              - T-PAY MICROSERVICE
            </Box>
          </Typography>
        </Box>

        {isMobile ? (
          <IconButton color="inherit" aria-label="open menu">
            <MenuIcon fontSize="large" sx={{ color: "#ffffff" }} />
          </IconButton>
        ) : (
          /* Contact Info Section */
          <Box
            sx={{
              display: "flex",
              fontWeight: 700,
              alignItems: "center",
              gap: { xs: 1, lg: 3 },
            }}
          >
            <ContactItem
              icon={
                <PhoneIcon
                  fontSize="medium"
                  sx={{ fontWeight: 700, color: "#ffffff" }}
                />
              }
              text="020 289 2000"
            />
            <ContactItem
              icon={
                <EmailIcon
                  fontSize="medium"
                  sx={{ fontWeight: 700, color: "#ffffff" }}
                />
              }
              text="info@tsc.go.ke"
              href="mailto:info@tsc.go.ke"
            />
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

// Reusable contact item component
const ContactItem: React.FC<{
  icon: React.ReactNode;
  text: string;
  href?: string;
}> = ({ icon, text, href }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        color: "#ffffff",
      }}
    >
      {icon}
      {href ? (
        <Link
          href={href}
          color="#ffffff"
          underline="hover"
          sx={{
            fontWeight: 500,
            fontSize: { xs: "1rem", md: "1.125rem" },
            "&:hover": { color: "#cc9e4a" },
          }}
        >
          {text}
        </Link>
      ) : (
        <Typography
          component="span"
          sx={{
            fontWeight: 500,
            fontSize: { xs: "1rem", md: "1.125rem" },
          }}
        >
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default Header;
